import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'

import { ActionButton, useModalContext } from '../../../../ui'
import { DocumentsView } from '../documents-view'
import { HEADER_BUTTONS_CONFIG } from '../../constants'

export const HeaderButtons = ({ application }) => {
  const { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useModalContext()

  const handlers = {
    viewDocuments: () =>
      open({
        Component: DocumentsView,
        data: { application },
        type: 'responsive',
        maxWidth: 'sm',
      }),
  }

  return (
    <Box display="flex" flexWrap="wrap">
      <Box display="flex" flexGrow={2} flexWrap="wrap">
        {HEADER_BUTTONS_CONFIG.map((button, i) => (
          <ActionButton
            key={i}
            {...button}
            onClick={handlers[button.id]}
            label={formatMessage({ id: button.label })}
          />
        ))}
      </Box>
    </Box>
  )
}
